import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PartItem, PartTableEvent } from '../../Models/PartsTable';
import { Property } from '../../../back-office/Models/Property';

@Component({
  selector: 'app-parts-table',
  templateUrl: './parts-table.component.html',
})
export class PartsTableComponent {
  @Input() parts: PartItem[] = [];
  @Input() isUpdating: boolean = false;
  @Input() showTable: boolean = true;
  @Input() multipliers: Property[] = [];

  @Output() updateAmount = new EventEmitter<PartTableEvent>();
  @Output() removePart = new EventEmitter<PartTableEvent>();
  @Output() updateMultiplier = new EventEmitter<PartTableEvent>();

  onAmountChange(index: number, event: Event): void {
    const newAmount = parseInt((event.target as HTMLInputElement).value);
    const partId = this.parts[index].part.id;
    
    this.updateAmount.emit({
      index,
      partId,
      amount: newAmount
    });
  }

  onRemovePart(index: number): void {
    const partId = this.parts[index].part.id;
    
    this.removePart.emit({
      index,
      partId
    });
  }

  onMultiplierChange(index: number, selectedPropertyId: number | null): void {
    const partId = this.parts[index].part.id;
    
    this.updateMultiplier.emit({
      index,
      partId,
      propertyId: selectedPropertyId
    });
  }
} 